import { event, GtagEvent } from "./event";
import { Item } from "./item";

export interface ViewPromotion extends GtagEvent {
    creative_name?:string;
    creative_slot?:string;
    promotion_id?:string;
    promotion_name?:string;
    items:Item[];
}
export const view_promotion = ($_:ViewPromotion) => event('view_promotion',$_);